import NextLink from 'next/link';
import styled from 'styled-components';

export const Link = styled(NextLink)`
  color: #131315;
  cursor: pointer;
`;
